"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const checkbox_1 = __importDefault(require("components/cosmos/checkbox/checkbox"));
const DatePicker_1 = __importDefault(require("components/date/DatePicker"));
const input_1 = require("components/input");
const translate_1 = require("components/translate");
const constants_1 = require("modules/content/constants");
require("./Dripping.scss");
const LiberationByDate = ({ active, setActive, value, onChange, errors, t }) => {
    const className = (0, classnames_1.default)('dripping__box', {
        active,
        error: errors.length > 0
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsx)(checkbox_1.default, { onChange: () => setActive(constants_1.LIBERATION_TYPE.BY_DATE), checked: active, id: "liberation-by-date", label: t('dripping.date.title') }), (0, jsx_runtime_1.jsx)("label", { className: "label__description mb__md", children: t('dripping.date.description', { checkOnlineEvent: true }) }, "label__description"), (0, jsx_runtime_1.jsxs)(input_1.InputBlock, { inline: true, labelValue: "dripping.release_in", children: [(0, jsx_runtime_1.jsx)(DatePicker_1.default, { date: value, onDateChange: onChange }), errors === null || errors === void 0 ? void 0 : errors.map((error) => ((0, jsx_runtime_1.jsx)("p", { className: "error", children: t(error) }, error)))] })] }));
};
exports.default = (0, translate_1.translate)()(LiberationByDate);
